import React from "react";
import "./Loading.css";

const LodingCirlce = ({ pending = false }) => {
  return (
    <div
      className="loadin-main-box"
      style={pending ? { display: "flex" } : { display: "none" }}
    >
      {pending && (
        <div class="spinner">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
      )}
    </div>
  );
};

export default LodingCirlce;
